import { useEffect } from 'react'
import { useUI } from '../context/UIContext'
import { setSessionRefreshHandlers } from '../services/api'

/** Registers API hooks so axios can show UI while `POST /auth/refresh` runs. */
export function SessionRefreshBridge() {
  const { setLoading, clearLoading } = useUI()
  useEffect(() => {
    setSessionRefreshHandlers({
      onStart: () => setLoading('sessionRefresh', true),
      onEnd: () => clearLoading('sessionRefresh'),
    })
    return () => setSessionRefreshHandlers(null)
  }, [setLoading, clearLoading])
  return null
}
